import React, { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import StorageService, { STORAGE_KEYS } from '../utils/storage.util';
import { decodeAccessToken, decodeIdToken, decodeMetadataToken } from '../utils/token.utils';

// A mock authentication function
export const isAuthenticated = () => {
    try {
        const accessToken = StorageService.getItem(STORAGE_KEYS.ACCESS_TOKEN);
        if(!accessToken) return false;
        const decodedAccessToken = decodeAccessToken();
        if(!decodedAccessToken || (decodedAccessToken.exp * 1000) < Date.now() ) return false;
        return true
    } catch (error) {
        return false;
    }
};

const ProtectedRoute = ({ children } : any) => {
    const navigate = useNavigate();
    
    useEffect(() => {
        if (!isAuthenticated()) {
            navigate('/logout', { replace: true });
            return;
        }
        
        // Check if user has a valid subscription
        try {
            const idToken = decodeIdToken();
            const metadataToken = decodeMetadataToken();
            
            // User is logged in with SSO (has preferred_username) and has null subscription
            if (idToken?.identities[0] && idToken?.preferred_username && metadataToken?.companies?.[0]?.subscription == null) {
                const params = new URLSearchParams({
                    planId: localStorage.getItem('planId') || 'All-In-One-USD-Monthly-100'
                });
                // Redirect to SSO signup page when subscription is null
                navigate(`/sso-signup?${params.toString()}`, { replace: true });
            }
        } catch (error) {
            console.error('Error checking subscription:', error);
        }
    }, [navigate]);
    
    return children;
};

export default ProtectedRoute;